import { takeLatest, put } from "redux-saga/effects";
import { FETCH_SYNTHESE_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import {
  fetchSyntheseSuccess,
  fetchSyntheseFailure,
  redirectToLogin,
} from "./actions";
import axios from "axios";
import Config from "config";
function* fetchSynthese(action) {
  // const { token} = action.payload;
  const api = Config.backOffice.apiName;

  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_synthese_annuelle`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchSyntheseSuccess(response.data));
  } catch (error) {
    // yield put(fetchSyntheseFailure(error));
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* syntheseSaga() {
  yield takeLatest(FETCH_SYNTHESE_REQUEST, fetchSynthese);
}

export default syntheseSaga;
